import React from 'react';

import { Segment, Grid, Statistic } from 'semantic-ui-react';

const StatCard = ({ label, value }) => (
  <Statistic
    size="tiny"
    color="purple"
    style={{ margin: 0 }}
  >
    <Statistic.Label
      content={label || <>&nbsp;</>}
      style={{ color: '#666', textAlign: 'left', fontSize: 13.5, fontWeight: 600, letterSpacing: '.02em', maxWidth: 150 }}
    />
    <Statistic.Value
      content={value}
      style={{ marginTop: 2, color: '#3b579d', textAlign: 'left' }}
    />
  </Statistic>
);

const SummaryBox = ({ icon, headline, text, statCards }) => (
  <Segment style={{ border: '1px solid #e7eafc' }}>
    <Grid>
      <Grid.Row>
        <Grid.Column width={8}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', height: '100%' }}>
            {icon && <div style={{ padding: '0px 20px 0 10px' }}>{icon}</div>}
            <div style={{ flexGrow: 1 }}>
              {headline && (
                <h4 style={{ marginBottom: 8 }}>
                  {headline}
                </h4>
              )}
              {text && (
                <h5 style={{ marginTop: 0, fontWeight: 400 }}>
                  {text}
                </h5>
              )}
            </div>
          </div>
        </Grid.Column>
        <Grid.Column width={8}>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', height: '100%', maxWidth: 650, margin: 'auto' }}>
            {statCards.map(stat => <StatCard label={stat.label} value={stat.value} />)}
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Segment>
);

export default SummaryBox;
